<template>
  <DefaultLayout>
    <div slot="content">
      <v-dialog v-model="featureLimitedModal" width="400" persistent>
        <v-card>
          <v-card-title>Feature limited</v-card-title>
          <v-card-text>{{featureLimitedText || featureLimitedDefaultText}}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn tile text color="blue" @click="featureLimitedModal = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="shapeLinkDialog" scrollable max-width="800">
        <v-card>
          <v-card-title>{{ modalTitle }}
            <v-spacer></v-spacer>
            <v-btn @click="shapeLinkDialog = false" icon><v-icon>close</v-icon></v-btn>
          </v-card-title>
          <v-card-text>
            <v-form ref="templateForm">
              <v-text-field id="new-profile-template-name" v-bind:value="shapeLinkName" v-on:blur="shapeLinkName = $event.target.value" label="QuickLink name" type="text" :rules="[v => !!v || 'Please enter QuickLink name']" style="max-width: 300px;"></v-text-field>
                <v-row class="align-center">
                  <v-col cols="5" sm="3" class="body-2 font-weight-medium grey--text text--darken-1">QuickLink enabled</v-col>
                  <v-col cols="1" sm="3" class="py-0">
                    <v-switch id="new-profile-template-notify-requester-purge" class="mt-0" hide-details color="blue" v-model="active"></v-switch>
                  </v-col>
                </v-row>
                <h3 class="mt-5">Options</h3>
                <v-divider class="my-4"></v-divider>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-row class="align-center">
                      <v-col cols="12" sm="7" class="body-2 font-weight-medium grey--text text--darken-1">Guest request</v-col>
                      <v-col cols="12" sm="5" class="py-0">
                        <v-switch id="new-profile-template-notify-requester-purge" class="mt-0" hide-details color="blue" v-model="guestRequest"></v-switch>
                      </v-col>
                    </v-row>
                    <v-row class="align-center">
                      <v-col cols="12" sm="7" class="body-2 font-weight-medium grey--text text--darken-1">First name enabled</v-col>
                      <v-col cols="12" sm="5" class="py-0">
                        <v-switch id="new-profile-template-notify-requester-purge" class="mt-0" hide-details color="blue" v-model="firstNameEnabled"></v-switch>
                      </v-col>
                    </v-row>
                    <v-row class="align-center">
                      <v-col cols="12" sm="7" class="body-2 font-weight-medium grey--text text--darken-1">Last name enabled</v-col>
                      <v-col cols="12" sm="5" class="py-0">
                        <v-switch id="new-profile-template-notify-requester-purge" class="mt-0" hide-details color="blue" v-model="lastNameEnabled"></v-switch>
                      </v-col>
                    </v-row>
                    <v-row class="align-center">
                      <v-col cols="12" sm="7" class="body-2 font-weight-medium grey--text text--darken-1">Email enabled</v-col>
                      <v-col cols="12" sm="5" class="py-0">
                        <v-switch id="new-profile-template-notify-requester-purge" class="mt-0" hide-details color="blue" v-model="emailEnabled"></v-switch>
                      </v-col>
                    </v-row>
                    <v-row class="align-center">
                      <v-col cols="12" sm="7" class="body-2 font-weight-medium grey--text text--darken-1">Mobile enabled</v-col>
                      <v-col cols="12" sm="5" class="py-0">
                        <v-switch id="new-profile-template-notify-requester-purge" class="mt-0" hide-details color="blue" v-model="mobileEnabled"></v-switch>
                      </v-col>
                    </v-row>
                    <v-row class="align-center">
                      <v-col cols="12" sm="7" class="body-2 font-weight-medium grey--text text--darken-1">Requester</v-col>
                      <v-col cols="12" sm="5" class="py-0">
                        <v-select dense :items="account.users" v-model="requesterId" label="Select" :item-text="userNameText" item-value="userId">       </v-select>               
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-row class="align-center">
                      <v-col cols="12" sm="7" class="body-2 font-weight-medium grey--text text--darken-1">Profile template</v-col>
                      <v-col cols="12" sm="5" class="py-0">
                        <v-select id="new-profile-template-declined-outcome" class="body-2" hide-details dense :items="templates" item-text="name" item-value="id" v-model="template"></v-select>
                      </v-col>
                    </v-row>
                    <v-row class="align-center">
                      <v-col cols="12" sm="7" class="body-2 font-weight-medium grey--text text--darken-1">First name mandatory</v-col>
                      <v-col cols="12" sm="5" class="py-0">
                        <v-switch id="new-profile-template-notify-user-outcome" class="mt-0" hide-details color="blue" v-model="firstNameMandatory"></v-switch>
                      </v-col>
                    </v-row>
                    <v-row class="align-center">
                      <v-col cols="12" sm="7" class="body-2 font-weight-medium grey--text text--darken-1">Last name mandatory</v-col>
                      <v-col cols="12" sm="5" class="py-0">
                        <v-switch id="new-profile-template-notify-user-outcome" class="mt-0" hide-details color="blue" v-model="lastNameMandatory"></v-switch>
                      </v-col>
                    </v-row>
                    <v-row class="align-center">
                      <v-col cols="12" sm="7" class="body-2 font-weight-medium grey--text text--darken-1">Email mandatory</v-col>
                      <v-col cols="12" sm="5" class="py-0">
                        <v-switch id="new-profile-template-notify-user-outcome" class="mt-0" hide-details color="blue" v-model="emailMandatory"></v-switch>
                      </v-col>
                    </v-row>
                    <v-row class="align-center">
                      <v-col cols="12" sm="7" class="body-2 font-weight-medium grey--text text--darken-1">Mobile mandatory</v-col>
                      <v-col cols="12" sm="5" class="py-0">
                        <v-switch id="new-profile-template-notify-user-outcome" class="mt-0" hide-details color="blue" v-model="mobileMandatory"></v-switch>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <h3 class="mt-5">References</h3>
                <v-divider class="my-4"></v-divider>                    
                <v-row v-for="item in references" :key="item.id" class="align-center pt-3 pb-4">
                  <v-col cols="12" sm="4" class="py-0">
                    <v-text-field required hide-details v-bind:value="item.name" v-on:blur="item.name = $event.target.value" label="Name" type="text" :rules="[v => !!v || '']"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" class="py-0">
                    <v-text-field required hide-details v-bind:value="item.value" v-on:blur="item.value = $event.target.value" label="Default value" type="text"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="1" class="py-0" v-if="references && references.length > 1">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" small icon color="red" @click="removeReference(item.id)"><v-icon small>fal fa-trash-alt</v-icon></v-btn>
                      </template>
                      <span>Remove item</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
                <v-btn small dark tile depressed color="blue" class="mt-4" @click="addReference"><v-icon small left dark>fal fa-plus</v-icon>Add reference</v-btn>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn tile text color="blue" @click="shapeLinkDialog = false">Close</v-btn>
            <v-btn id="new-profile-template-save" tile dark depressed color="blue" @click="saveShapeLink">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="confirmDeleteShapeLinkDialog" persistent max-width="425">
        <v-card>
        <v-card-text class="body-1 pt-5">Are you sure you want to delete QuickLink <span class="whitespace-nowrap">{{shapeLinkToDelete.name}}</span>?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn tile text @click="confirmDeleteShapeLinkDialog = false">Close</v-btn>
            <v-btn tile dark depressed color="red" @click="deleteShapeLink">Delete</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="qrCode" width="400">
        <v-card class="text-center">
          <v-card-text class="body-1 pt-7">1) Right-click the QR code.<br/>
2) Choose the command Save Picture As.<br/>
3) Use the Save Picture dialog box to find a location to save the picture.<br/>
4) Click the Save button.</v-card-text>
          <v-card-text>
            <vue-qr :logoSrc="logoSrc2" :text="qrCodeLink" :logoScale="0.2" :dotScale="0.5" :size="350" colorDark="#0A7BD9" colorLight="#fff"></vue-qr>
          </v-card-text>
        </v-card>
      </v-dialog>

      <div class="d-flex align-center mb-3">
        <div class="title" @click="updateShapeLinks">QuickLinks</div>
        <v-spacer></v-spacer>
        <v-btn id="add-profile-template" tile small dark depressed color="blue" @click="showDialog"><v-icon small left dark>fal fa-pencil-ruler</v-icon>New QuickLink</v-btn>
      </div>
      <v-divider class="mb-5"></v-divider>

      <template v-if="shapeLinks.list && shapeLinks.list.length">
        <v-card v-for="t in shapeLinks.list" :key="t.id" class="mb-10" style="border-radius: 20px !important;">
          <v-card-title>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-if="t.active" v-on="on" small class="mr-2" color="green">fas fa-circle</v-icon>
                <v-icon v-else v-on="on" small class="mr-2" color="red">fas fa-circle</v-icon>
              </template>
              <span v-if="t.active">QuickLink active</span>
              <span v-else>QuickLink disabled</span>
            </v-tooltip>
            {{ t.name }}
            <v-spacer></v-spacer>
            <p class="mb-0 text--disabled">{{ t.shortLinkHash }}</p>
            <v-btn tile small text color="grey" @click="toClipboard(t.shortLinkHash)"><v-icon small dark class="mr-2">far fa-copy</v-icon>Copy QuickLink to clipboard</v-btn>
            <v-btn tile small text color="green" @click="showQRCode(t.shortLinkHash)"><v-icon small dark class="mr-2">far fa-qrcode</v-icon>Show QR code</v-btn>
            <v-btn tile small text color="red" @click="confirmDeleteShapeLink(t)"><v-icon small dark class="mr-2">fal fa-trash-alt</v-icon>Delete</v-btn>
            <v-btn tile small text color="blue" @click="editShapeLink(t)"><v-icon small dark class="mr-2">fal fa-cog</v-icon>Options</v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="py-10">
            <v-row>
              <v-col sm="12" md="6" lg="3" class="py-0">
                <v-row class="pb-1">
                  <v-col sm="6" class="py-0 body-2 font-weight-medium">Guest request</v-col>
                  <v-col sm="6" class="py-0 body-2">{{ t.isGuest ? 'Yes' : 'No' }}</v-col>
                </v-row>
                <v-row class="pb-1">
                  <v-col sm="6" class="py-0 body-2 font-weight-medium">Template</v-col>
                  <v-col sm="6" class="py-0 body-2">{{ getTemplateName(t.profileTemplateId) }}</v-col>
                </v-row>
                <v-row class="pb-1">
                  <v-col sm="6" class="py-0 body-2 font-weight-medium">First name enabled</v-col>
                  <v-col sm="6" class="py-0 body-2">{{ t.firstNameEnabled ? 'Yes' : 'No' }}</v-col>
                </v-row>
                <v-row class="pb-1">
                  <v-col sm="6" class="py-0 body-2 font-weight-medium">First name mandatory</v-col>
                  <v-col sm="6" class="py-0 body-2">{{ t.firstNameMandatory ? 'Yes' : 'No' }}</v-col>
                </v-row>
              </v-col>
              <v-col sm="12" md="6" lg="3" class="py-0">
                <v-row class="pb-1">
                  <v-col sm="6" class="py-0 body-2 font-weight-medium">Last name enabled</v-col>
                  <v-col sm="6" class="py-0 body-2">{{ t.lastNameEnabled ? 'Yes' : 'No' }}</v-col>
                </v-row>
                <v-row class="pb-1">
                  <v-col sm="6" class="py-0 body-2 font-weight-medium">Last name mandatory</v-col>
                  <v-col sm="6" class="py-0 body-2">{{ t.lastNameMandatory ? 'Yes' : 'No' }}</v-col>
                </v-row>
                <v-row class="pb-1">
                  <v-col sm="6" class="py-0 body-2 font-weight-medium">Requester</v-col>
                  <v-col sm="6" class="py-0 body-2">{{ getRequester(t) }}</v-col>
                </v-row>
              </v-col>
              <v-col sm="12" md="6" lg="3" class="py-0">
                <v-row class="pb-1">
                  <v-col sm="6" class="py-0 body-2 font-weight-medium">Email enabled</v-col>
                  <v-col sm="6" class="py-0 body-2">{{ t.emailEnabled ? 'Yes' : 'No' }}</v-col>
                </v-row>
                <v-row class="pb-1">
                  <v-col sm="6" class="py-0 body-2 font-weight-medium">Email mandatory</v-col>
                  <v-col sm="6" class="py-0 body-2">{{ t.emailMandatory ? 'Yes' : 'No' }}</v-col>
                </v-row>
              </v-col>
              <v-col sm="12" md="6" lg="3" class="py-0">
                <v-row class="pb-1">
                  <v-col sm="6" class="py-0 body-2 font-weight-medium">Mobile enabled</v-col>
                  <v-col sm="6" class="py-0 body-2">{{ t.mobileEnabled ? 'Yes' : 'No' }}</v-col>
                </v-row>
                <v-row class="pb-1">
                  <v-col sm="6" class="py-0 body-2 font-weight-medium">Mobile mandatory</v-col>
                  <v-col sm="6" class="py-0 body-2">{{ t.mobileMandatory ? 'Yes' : 'No' }}</v-col>
                </v-row>
              </v-col>
            </v-row>
            <template v-if="t.references && t.references.length">
              <div class="subtitle-2 font-weight-bold mt-7 mb-3">References</div>
              <v-row>
                <v-col sm="12" md="6" lg="3" class="py-0" v-for="(detail, i) in t.references" :key="`${t.id}-${detail.name}-${i}`">
                  <span class="body-2">{{ detail.name }} : {{ detail.defaultValue == '' ? '----' : detail.defaultValue }}</span>
                </v-col>
              </v-row>
            </template>
          </v-card-text>
        </v-card>
      </template>
      <div v-if="!shapeLinks.list" class="text-center pt-12 mt-12 headline font-weight-bold grey--text">
        No QuickLink created
      </div>
    </div>
  </DefaultLayout>
</template>

<script>
import uuidv4 from 'uuid/v4';
import { mapState } from 'vuex';
import {
  GET_ACCOUNT_SHAPE_LINKS,
  SAVE_SHAPE_LINK,
  DELETE_SHAPE_LINK
} from '@/store/actions.type';
import DefaultLayout from '@/layouts/DefaultLayout';
import { customizableEmailTemplates } from '@/helpers/constants';
import VueQrcode from 'vue-qrcode';
import logoSrc from "../assets/logopv.png";
import logoSrc2 from "../assets/PVQRcodeDraft.png";

export default {
  name: 'shape-links',
  components: {
    DefaultLayout,
    VueQrcode
  },
  data() {
    return {
      logoSrc,
      logoSrc2,
      shapeLinkId: null,
      guestRequest: false,
      active:true,
      firstNameEnabled: true,
      firstNameMandatory: false,
      lastNameEnabled: true,
      lastNameMandatory: false,
      emailEnabled: true,
      emailMandatory: false,
      mobileEnabled: false,
      mobileMandatory: false,
      template: null,
      references: [{ id: '089861de-3fdd-49dd-858e-dc98af281e3f', name: 'Reference', ordinal: 0, value: '' }],
      shapeLinks: [],
      qrCodeLink: '',
      qrCode: false,
      featureLimitedModal: false,
      featureLimitedText: '',
      featureLimitedDefaultText: 'To enable this feature, you need to upgrade your price plan.',
      shapeLinkDialog: false,
      confirmDeleteShapeLinkDialog: false,
      shapeLinkToDelete: {name: ''},
      modalTitle: 'New QuickLink',
      shapeLinkName: '',
      isEdit: false,
      requesterId: null
    };
  },
  watch: {
    account() {
      this.updateShapeLinks();
    },
  },
  computed: {
    ...mapState({ organization: state => state.organizations.userSelectedOrganization }),
    ...mapState({ account: state => state.organizations.userSelectedAccount }),
    ...mapState({ templates: state => state.profileTemplates.selectedAccountTemplates }),
    ...mapState({ limitations: state => state.organizations.userSelectedOrganization.limitations }),
  },
  methods: {
    getRequester(quickLink){
      let user = this.account.users.find(x => x.userId === quickLink.requesterUserId);
      if(user){
        return user.firstName + ' ' + user.lastName;
      }
      return '';
    },
    userNameText(item) {
      return item.firstName + ' ' + item.lastName;
    },
    showQRCode(text){
      this.qrCode = true;
      this.qrCodeLink = text;
    },
    toClipboard(text) {
        var input = document.createElement('input');
        input.setAttribute('value', text);
        document.body.appendChild(input);
        input.select();
        var result = document.execCommand('copy');
        document.body.removeChild(input);
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Copied to clipboard!',
        });
        return result;
    },
    getTemplateName(templateId){
      if(this.templates && this.templates.length > 0){
        let t = this.templates.find(e => e.id == templateId);
        if(t){
          return t.name
        } 
      }
      return 'Loading...'
    },
    showDialog(){
      this.shapeLinkId = uuidv4();
      this.shapeLinkName = '';
      this.modalTitle = 'New QuickLink';
      this.requesterId = this.account.users[0].userId;
      this.references = [{ id: '089861de-3fdd-49dd-858e-dc98af281e3f', name: 'Reference', ordinal: 0, value: '' }];

      if(this.templates && this.templates.length > 0){
        this.template = this.templates[0].id;
        this.shapeLinkDialog = true;
      }
      else{
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'To create QuickLink you need to add at least one profile template.',
        });        
      }
    },
    addReference() {
      let maxOrd = Math.max.apply(Math, this.references.map(function(o) { return o.ordinal; }))
      this.references.push({ id: uuidv4(), name: '', ordinal: maxOrd+1 , value: '' });
    },
    removeReference(id) {
      this.references = this.references.filter(x => x.id != id);
    },
    async updateShapeLinks() {
      try {
        this.shapeLinks = await this.$store.dispatch(GET_ACCOUNT_SHAPE_LINKS, this.account.accountId);
        console.log(this.shapeLinks)
      } catch (err) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Error getting QuickLinks. Please contact support@planetverify.com',
        });
      }
    },
    async saveShapeLink() {
      if (!this.$refs.templateForm.validate()) {
        return;
      }

      let refs = []
      this.references.forEach(el => {
        refs.push({ name: el.name, ordinal: el.ordinal, defaultValue: el.value });
      });

      const newShapeLink = {
        id: this.shapeLinkId,
        name: this.shapeLinkName,
        accountId: this.organization.id,
        groupId: this.account.accountId,
        profileTemplateId: this.template,
        requesterUserId: this.requesterId,
        active: this.active,
        isGuest: this.guestRequest,
        references: refs,
        firstNameEnabled: this.firstNameEnabled,
        firstNameMandatory: this.firstNameMandatory,
        lastNameEnabled: this.lastNameEnabled,
        lastNameMandatory: this.lastNameMandatory,
        emailEnabled: this.emailEnabled,
        emailMandatory: this.emailMandatory,
        mobileEnabled: this.mobileEnabled,
        mobileMandatory: this.mobileMandatory
      }
console.log(newShapeLink)
      try {
        await this.$store.dispatch(SAVE_SHAPE_LINK, newShapeLink);
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'QuickLink saved',
        });
        this.shapeLinkDialog = false;
        this.updateShapeLinks();
      } catch(err) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Error creating QuickLink. Please contact support@planetverify.com',
        });
      }
    },
    editShapeLink(shapeLink) {

      let refs = []
      shapeLink.references.forEach(el => {
        var ord = 0;
        if(el.ordinal){
          ord = el.ordinal;
        }
        refs.push({ id: uuidv4(), name: el.name, ordinal: ord, value: el.defaultValue });
      });

      this.shapeLinkId = shapeLink.id;
      this.active = shapeLink.active;
      this.shapeLinkName = shapeLink.name;
      this.template = shapeLink.profileTemplateId;
      this.guestRequest = shapeLink.isGuest;
      this.references = refs,
      this.firstNameEnabled = shapeLink.firstNameEnabled;
      this.firstNameMandatory = shapeLink.firstNameMandatory;
      this.lastNameEnabled = shapeLink.lastNameEnabled;
      this.lastNameMandatory = shapeLink.lastNameMandatory;
      this.emailEnabled = shapeLink.emailEnabled;
      this.emailMandatory = shapeLink.emailMandatory;
      this.mobileEnabled = shapeLink.mobileEnabled;
      this.mobileMandatory = shapeLink.mobileMandatory;
      this.requesterId = shapeLink.requesterUserId;

      this.modalTitle = 'Edit QuickLink';
      this.shapeLinkDialog = true;
    },
    confirmDeleteShapeLink(template) {
      this.shapeLinkToDelete = template;
      this.confirmDeleteShapeLinkDialog = true;
    },
    async deleteShapeLink() {
      try {
        await this.$store.dispatch(DELETE_SHAPE_LINK, { id: this.shapeLinkToDelete.id });
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'QuickLink deleted',
        });
        this.confirmDeleteShapeLinkDialog = false;
        this.updateShapeLinks();
      } catch(err) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Error deleting QuickLink. Please contact support@planetverify.com',
        });
        this.confirmDeleteShapeLinkDialog = false;
      }
    },
  },
  async mounted() {
    await this.updateShapeLinks();
  },
}
</script>

<style>
.v-expansion-panels.new-template-options {
  border-radius: 0;
}
.v-expansion-panels.new-template-options .v-expansion-panel::before {
  box-shadow: none;
}
.v-expansion-panels.new-template-options .v-expansion-panel:not(:first-child)::after {
  border-top: none;
}
.v-expansion-panels.new-template-options .v-expansion-panel-header {
  padding-left: 0;
  padding-right: 0;
  border-bottom: 1px solid rgba(0,0,0,.12);
}
.v-expansion-panels.new-template-options .v-expansion-panel-content__wrap {
  padding-left: 0;
  padding-right: 0;
}
</style>
